import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuComponent } from '../menu/menu.component';

@Component({
    selector: 'app-portada-simulador',
    templateUrl: './portada-simulador.component.html',
    //styleUrls: ['../../../assets/css/styles.css', '../../../assets/css/bootstrap.css']
})
export class PortadaSimuladorComponent implements OnInit {

    public displayModal: boolean = false;
    public classAviso: string = 'modal fade';
    public menu: MenuComponent;

    constructor(private _router: Router) {
        this.menu = new MenuComponent(_router);
    }

    ngOnInit(): void {

        /* para mostrar el aviso legal solo si aviso=1 */
        var url = window.location.href;
        var aviso = url.split('=').pop();
        if (aviso == '1') {
            this.displayModal = true;
        }

    }

    /**
    * 
    */
    public closeAviso(): void {
        this.classAviso = 'modal fade';
        this.displayModal = false;
    }

}
